var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'bg-default-login': _vm.isPagesBg,
    'is-login': _vm.isPageLogin,
    'is-config-layout': _vm.isConfigLayout,
  }},[_c('loading',{attrs:{"active":_vm.isLoading,"is-full-page":true}}),_c('Header',{attrs:{"array-pages-has-bg":_vm.arrayPagesHasBg}}),_c('main',[_c('RouterView')],1),(_vm.arrayPagesNotBtnHelp.indexOf(_vm.$route.name) === -1)?_c('BtnHelp'):_vm._e(),_c('ModalHelp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }